import { t_JoystickDataset } from '../joystick-movements-multi/joystick-movements-multi.component';
import { t_dataName } from '../../../../services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_joystickDataPoint = {
    generalName: string;
    dataName: t_dataName;
    value?: number;
};

export type t_JoystickButtonDataset = {
    dataPoints: t_joystickDataPoint[];
}

export const visualizationJoystickConfig: t_JoystickButtonDataset = {
    dataPoints: [
        {
            generalName: 'Joystick Right / Forward Backward',
            dataName: {
                name: 'JoystickRightForwardBackward',
            }
        },
        {
            generalName: 'Joystick Right / Left Right',
            dataName: {
                name: 'JoystickRightLeftRight',
            }
        },
        {
            generalName: 'Joystick Right Thumbwheel',
            dataName: {
                name: 'JoystickRightThumbWheel',
            }
        },
        {
            generalName: 'Joystick Right Slider Back',
            dataName: {
                name: 'JoystickRightSliderBack',
            }
        },
        {
            generalName: 'Joystick Right Fingertip Up Down',
            dataName: {
                name: 'JoystickRightFingertipUpDown',
            }
        },
        {
            generalName: 'Joystick Right Fingertip Left Right',
            dataName: {
                name: 'JoystickRightFingertipLeftRight',
            }
        },
        {
            generalName: 'Joystick Right Button S05',
            dataName: {
                name: 'JoystickRightButtonS05',
            }
        },
        {
            generalName: 'Joystick Right Button S06',
            dataName: {
                name: 'JoystickRightButtonS06',
            }
        },
        {
            generalName: 'Joystick Right Button S07',
            dataName: {
                name: 'JoystickRightButtonS07',
            }
        },
        {
            generalName: 'Joystick Right Button S08',
            dataName: {
                name: 'JoystickRightButtonS08',
            }
        },
        {
            generalName: 'Joystick Right Button S13',
            dataName: {
                name: 'JoystickRightButtonS13',
            }
        },
        {
            generalName: 'Joystick Right Button S15',
            dataName: {
                name: 'JoystickRightButtonS15',
            }
        },
        {
            generalName: 'Joystick Right Gear',
            dataName: {
                name: 'JoystickRightGearSelection',
            }
        },
    ],
};

export const joystickDataConfig: t_JoystickDataset[] = [
    {
        joystickName: 'Joystick Right',
        forwardBackward: { dataname: { name: 'JoystickRightForwardBackward' }, value: 0 },
        leftRight: { dataname: { name: 'JoystickRightLeftRight' }, value: 0 },
    },
];
